module.exports = __webpack_public_path__ + "img/PL09279.e4773ed2.png";